import { render, staticRenderFns } from "./Mesh.vue?vue&type=template&id=2f8a70fe&scoped=true"
import script from "./Mesh.vue?vue&type=script&lang=js"
export * from "./Mesh.vue?vue&type=script&lang=js"
import style0 from "./Mesh.vue?vue&type=style&index=0&id=2f8a70fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8a70fe",
  null
  
)

export default component.exports